import React, { Component } from 'react';
import NormalLink from './NormalLink';

const displayStyle = { display: 'block'};
const noDisplayStyle = { display: 'none'};

export class DropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    };

    componentDidMount () {
        let activeUrlList = this.props.list.filter(item => item.url === this.props.activeUrl);
        if (activeUrlList && activeUrlList.length > 0) {
            this.setState({
                isOpen: true
            });
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.activeUrl !== this.props.activeUrl) {
            let activeUrlList = this.props.list.filter(item => item.url === this.props.activeUrl);
            if (activeUrlList && activeUrlList.length > 0) {
                this.setState({
                    isOpen: true
                });
            }
        }
    };

    getBlockClass = () => {
        let text = 'hasChild';
        let activeUrlList = this.props.list.filter(item => item.url === this.props.activeUrl);
        if (activeUrlList && activeUrlList.length > 0) {
            text += 'open active';
        } else if (this.state.isOpen) {
            text += ' open';
        }
        return text;
    };

    toggleOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };

    render() {
        return (
            <li className={this.getBlockClass()} onClick={() => this.toggleOpen()}>
                <a href="#" ><i className={this.props.icon} />
                    {
                        this.props.isShowSideBar ?
                            <span>{this.props.name}</span> : null
                    }
                </a>
                <ul className="acc-menu" style={this.state.isOpen ? displayStyle : noDisplayStyle}>
                    {this.props.isShowSideBar && this.props.list.map((item) => (
                        <NormalLink
                            key={item.url}
                            name={item.name}
                            url={item.url}
                            icon={item.icon}
                            activeUrl={this.props.activeUrl}
                            isShowSideBar={this.props.isShowSideBar}
                        />
                    ))}
                </ul>
            </li>
        );
    }
}

export default DropDown;

